function transformErrors(errors) {
  return errors;
}

export default transformErrors;



// WEBPACK FOOTER //
// ./src/byob-cms/src/formLib/transformErrors.js